import * as S from "./EquipmentTemplate.style";
import { Legend } from "../../molecules/Legends";
import { TabList } from "../../molecules/TabList";
import { EquipmentDefaultValuesTypes } from "../../../types/equipment";
import { ShipOperationStatus } from "../../../common/types/ship";

interface EquipmentProps {
  selectedTab: number;
  setSelectedTab: any;
  data?: any;
  onContextMenu: (event: React.MouseEvent, target: any) => void;
  localCurrentShip?: EquipmentDefaultValuesTypes;
  shipOperationStatus?: ShipOperationStatus;
}

export const EquipmentTemplate = ({
  selectedTab,
  setSelectedTab,
  data,
  onContextMenu,
  localCurrentShip,
  shipOperationStatus,
}: EquipmentProps) => {
  return (
    <S.EquipmentTemplate>
      <S.EquipmentTopbar>
        <S.EquipmentShipTitle>
          {localCurrentShip?.shipTypeName ?? ""}
          {localCurrentShip?.shipTypeName &&
            localCurrentShip?.shipName &&
            " / "}
          {localCurrentShip?.shipName}
        </S.EquipmentShipTitle>
        <Legend
          type="sailing-info"
          title="함정 운항정보"
          shipOperationStatus={shipOperationStatus}
        />
      </S.EquipmentTopbar>
      <S.EquipmentTabBox>
        <TabList
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          data={data}
          onContextMenu={onContextMenu}
          isUseClose={false}
        />
      </S.EquipmentTabBox>
      {data[selectedTab].component}
    </S.EquipmentTemplate>
  );
};
